import { ReportExportStringsMode } from 'app/modules/reports/features/extracted-strings/types'
import { SignalVerdict } from 'app/modules/reports/types'

export enum ReportFormat {
  Misp = 'misp',
  Stix = 'stix',
  Html = 'html',
  Pdf = 'pdf',
  Raw = 'raw',
}

export enum ReportFormatSlow {
  Html = 'html',
  Pdf = 'pdf',
}

export enum ReportFormatState {
  Created = 'created',
  Queued = 'queued',
  In_progress = 'in_progress',
  Failed = 'failed',
  Success = 'success',
}

export type ReportFormatSettings = {
  strings_limit: number
  strings_mode: ReportExportStringsMode
}

export type ReportFormatItem = {
  id: string
  flow_id: string
  report_id: string
  file_name: string
  file_sha256: string
  verdict: SignalVerdict
  format: ReportFormatSlow
  state: ReportFormatState
  created_date: string
  started_date: string | null
  finished_date: string | null
  settings: ReportFormatSettings
}
